<template> 
	<div class="inner with-content">
		<a href="" class="go-back">
			<simple-svg 
				:filepath="'/images/SVG/ArrowLeft.svg'"
				:width="'9px'"
				:height="'16px'"
			/>
		</a>

		<div class="headline">
			<h1>{{getSingleProperty.address}} </h1>
			<p>{{getSingleProperty.zip_code}} {{getSingleProperty.city}}</p>

			<!-- <div class="actions">
				<a href="" class="circle-icon">
					<simple-svg 
						:filepath="'/images/SVG/Settings.svg'"
						:width="'20px'"
						:height="'20px'"
					/>
				</a>
			</div> -->
		</div>

		<tabs>
			<tab :name="$t('property.tabs.screenings')">
				<v-client-table :columns="columns" :data="screenings" :options="options" ref="table" class="screenings-table">

                    <div slot="beforeFilter" class="intro">
                        <h2>{{$t('screenings.overview.headline')}}</h2>
                    </div>
                    <div slot="afterFilter" class="add-button">
                    	<div class="data-input select-field sorting" style="">
                            <div class="select-container">
                                <select v-model="screeningSorting" v-on:change="setTableSorting('all', screeningSorting)">
                                    <option value="">{{ $t('sort.newest-first') }}</option>
                                    <option value="10">{{ $t('sort.oldest-first') }}</option>
                                    <option value="50">{{ $t('sort.candidate-ascending') }}</option>
                                    <option value="40">{{ $t('sort.status-ascending') }}</option>
                                    <option value="20">{{ $t('sort.address-ascending') }}</option>
                                    <option value="30">{{ $t('sort.zipcode-ascending') }}</option>
                                </select>
                                <span class="arrow">
                                    <SvgIcon icon="sort-icon" />
                                </span>
                            </div>
                        </div>
                        <form>
                            <div class="icon">
                                <SvgIcon icon="search" />
                            </div>
                            <input type="text" v-model="filterText" v-on:keyup="filterTable('all')" autofill="off" autocomplete="false" :placeholder="$t('search.filterplaceholder')">
                        </form>
                        <a href="/screenings/select-property" class="button green">
                            <SvgIcon icon="plus-circle" />
                            	{{$t('screening.new.button')}}
                        </a>
                    </div>
                        <a slot="more" slot-scope="props">
                            <table-dropdown>
                                <li>Delete</li>
                            </table-dropdown>
                        </a>
                </v-client-table>
			</tab>
			<tab :name="$t('property.tabs.contracts')">
				<tabs class="with-subtabs">
					<tab :name="$t('contracts.tabs.all')">
						
						<v-client-table :columns="subColumns" :data="allContracts" :options="subOptions" ref="table" class="screenings-table">

		                    <div slot="beforeFilter" class="intro">
		                        <h2>{{$t('contracts.overview.all.headline')}}</h2>
		                    </div>
		                    <div slot="afterFilter" class="add-button">
		                        <div class="icon">
		                            <simple-svg
		                                :filepath="'/images/SVG/Search.svg'"
		                                :width="'20px'"
		                                :height="'20px'"
		                                   
		                            />
		                        </div>
		                        <a href="/contracts/choose-type" class="button green">
		                            <SvgIcon icon="plus-circle" />
                                	{{$t('contracts.addnew.button')}}
		                        </a>
		                    </div>
		                    <a slot="more" slot-scope="props">
		                        <table-dropdown>

		                        </table-dropdown>
		                    </a>
		                </v-client-table>
					</tab>
					<tab :name="$t('contracts.tabs.drafts')">
						<v-client-table :columns="subColumns" :data="drafts" :options="subOptions" ref="table" class="screenings-table">

		                    <div slot="beforeFilter" class="intro">
		                        <h2>{{$t('contracts.overview.draft.headline')}}</h2>
		                    </div>
		                    <div slot="afterFilter" class="add-button">
		                        <div class="icon">
		                            <simple-svg
		                                :filepath="'/images/SVG/Search.svg'"
		                                :width="'20px'"
		                                :height="'20px'"
		                                   
		                            />
		                        </div>
		                        <a href="/contracts/choose-type" class="button green">
		                            <SvgIcon icon="plus-circle" />
                                	{{$t('contracts.addnew.button')}}
		                        </a>
		                    </div>
		                    <a slot="more" slot-scope="props">
		                        <table-dropdown>

		                        </table-dropdown>
		                    </a>
		                </v-client-table>
					</tab>
					<tab :name="$t('contracts.tabs.signed')">
						<v-client-table :columns="subColumns" :data="signed" :options="subOptions" ref="table" class="screenings-table">

		                    <div slot="beforeFilter" class="intro">
		                        <h2>{{ $t('contracts.overview.signed.headline') }}</h2>
		                    </div>
		                    <div slot="afterFilter" class="add-button">
		                        <div class="icon">
		                            <simple-svg
		                                :filepath="'/images/SVG/Search.svg'"
		                                :width="'20px'"
		                                :height="'20px'"
		                                   
		                            />
		                        </div>
		                        <a href="/contracts/choose-type" class="button green">
		                            <SvgIcon icon="plus-circle" />
                                	{{$t('contracts.addnew.button')}}
		                        </a>
		                    </div>
		                    <a slot="more" slot-scope="props">
		                        <table-dropdown>

		                        </table-dropdown>
		                    </a>
		                </v-client-table>
					</tab>
					<tab :name="$t('contracts.tabs.awaitingtenantsignature')">
						<v-client-table :columns="subColumns" :data="unsigned" :options="subOptions" ref="table" class="screenings-table">

		                    <div slot="beforeFilter" class="intro">
		                        <h2>{{$t('contracts.overview.awaitingtenantsignature.headline')}}</h2>
		                    </div>
		                    <div slot="afterFilter" class="add-button">
		                        <div class="icon">
		                            <simple-svg
		                                :filepath="'/images/SVG/Search.svg'"
		                                :width="'20px'"
		                                :height="'20px'"
		                                   
		                            />
		                        </div>
		                        <a href="/contracts/choose-type" class="button green">
		                            <SvgIcon icon="plus-circle" />
                                	{{$t('contracts.addnew.button')}}
		                        </a>
		                    </div>
		                    <a slot="more" slot-scope="props">
		                        <table-dropdown>

		                        </table-dropdown>
		                    </a>
		                </v-client-table>
					</tab>
					<tab :name="$t('contracts.tabs.legacy')">
						<v-client-table :columns="subColumns" :data="legacy" :options="subOptions" ref="table" class="screenings-table">

		                    <div slot="beforeFilter" class="intro">
		                        <h2>{{$t('contracts.overview.legacy.headline')}}</h2>
		                    </div>
		                    <div slot="afterFilter" class="add-button">
		                        <div class="icon">
		                            <simple-svg
		                                :filepath="'/images/SVG/Search.svg'"
		                                :width="'20px'"
		                                :height="'20px'"
		                                   
		                            />
		                        </div>
		                        <a href="/contracts/choose-type" class="button green">
		                            <SvgIcon icon="plus-circle" />
                                	{{$t('contracts.addnew.button')}}
		                        </a>
		                    </div>
		                    <a slot="more" slot-scope="props">
		                        <table-dropdown>

		                        </table-dropdown>
		                    </a>
		                </v-client-table>
					</tab>
				</tabs>
			</tab>
		</tabs>

	</div>
</template>
<script>
	
	import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';
    import {mapGetters} from 'vuex';
    import {store} from '../../store/index';
    import TableDropdown from '../../components/TableDropdown';
    import SvgIcon from '../../components/Svg.vue';

    Vue.use(ClientTable);

    export default {
    	components:{
            TableDropdown,
            SvgIcon
        },
    	data: () => ({
    		filterText: '',
            screeningSorting: '',
    		screenings: [],
    		contracts: [],
    		columns: ['canditate', 'status', 'deadline', 'invitated', 'more'],
    		options: {
    			headings: {
    				canditate: 'Canditate',
    				status: 'Status',
    				deadline: 'Dealine',
    				invitated: 'Invitated by'
    			},
    			sortable: ['candidate'],
    			filterable: ['candidate', 'status', 'deadline'],
    			texts:{
                    filterPlaceholder: 'Search',
                    filter: ''
                },
                columnsClasses: {
                	canditate: 'canditate',
    				status: 'status',
    				deadline: 'deadline',
    				invitated: 'invitated'
                }
    		},
    		allContracts: [],
    		drafts: [],
    		signed: [],
    		unsigned: [],
    		legacy: [],
    		subColumns: ['occupancy_date', 'tenant', 'status', 'more'],
    		subOptions: {
    			headings: {
    				occupancy_date: 'Occupancy date',
    				tenant: 'Tenant',
    				status: 'Status'	
    			},
    			sortable: ['occupancy_date', 'status'],
    			filterable: ['occupancy_date', 'tenant'],
    			texts:{
                    filterPlaceholder: 'Search',
                    filter: ''
                },
                columnsClasses: {
                	occupancy_date: 'date',
    				tenant: 'tenant',
    				status: 'status',
    				more: 'more'	
                }
    		}

    	}),
    	computed: {
    		...mapGetters([
                'getSingleProperty',
                'getToken'
            ])
    	},
    	methods: {
    		filterTable(ref, value) {
                this.$refs[ref].setFilter(this.filterText);
            }
    	}
    }

</script>
<style></style>